import { ColumnsType } from "antd/es/table";
import {
  getColumnsParamsType,
  JobTableDataResponseType,
} from "../../../../Types/DatabaseTabTypes";
import { Popover } from "antd";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { EllipsisOutlined } from "@ant-design/icons";
import { MdModeEdit } from "react-icons/md";
import styles from "./JobTable.module.scss";
import BlockIcon from "../../../../assets/images/lockIconOutline.svg";
import UnblockIcon from "../../../../assets/images/unlockIconOutline.svg";
import clsx from "clsx";
import { JobStatus } from "../../../../enums/DatabaseEnums";
import DescriptionCell from "../../../../reusable-components/DescriptionCell";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";

export const getColumns = (
  params?: getColumnsParamsType,
): ColumnsType<JobTableDataResponseType> => [
  {
    title: "JOB",
    key: "job",
    align: "center",
    dataIndex: "jobNumber",
    width: "150px",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedJob]: !!params?.blockedJob,
        })}
      >
        {val}
      </span>
    ),
  },
  {
    title: "JOB NAME",
    key: "jobName",
    align: "center",
    dataIndex: "jobName",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedJob]: !!params?.blockedJob,
        })}
      >
        {val}
      </span>
    ),
  },
  {
    title: "CONTACT NAME",
    key: "contactName",
    align: "center",
    dataIndex: "contactName",
    width: "300px",
    render: (val, record) => (
      <span
        className={clsx("table-font-mobile", {
          [styles.blockedJob]: !!params?.blockedJob,
        })}
      >
        {val}
      </span>
    ),
  },
  {
    title: "MATERIAL",
    key: "material",
    align: "center",
    dataIndex: "material",
    width: "300px",
    render: (val) => (
      <DescriptionCell
        text={val}
        width="300px"
        placement={PlacementPositions.LEFT}
        disabled={!!params?.blockedJob}
      />
    ),
  },
  {
    title: "STATUS",
    key: "status",
    align: "center",
    dataIndex: "jobStatus",
    width: "150px",
    render: (val, record) => (
      <div
        className={clsx(styles.jobStatusContainer, {
          [styles.approvedStatusColor]: val === JobStatus.APPROVED,
          [styles.notApprovedStatusColor]: val === JobStatus.NOT_APPROVED,
          [styles.closedStatusColor]: val === JobStatus.CLOSED,
          [styles.blockedJob]: !!params?.blockedJob,
        })}
      >
        <div className={styles.prevDot}>{"• "}</div>
        <div>{val}</div>
      </div>
    ),
  },
  {
    title: "",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    align: "right",
    render: (_, record) => {
      return (
        <ConditionalRender visible={params?.noActionDropFields}>
          <Popover
            placement={PlacementPositions.LEFT}
            content={
              <>
                <ConditionalRender visible={!!!params?.blockedJob}>
                  <div
                    className={styles.PopoverContent}
                    onClick={async () => {
                      await params?.handleEditNavigate(record?.id);
                    }}
                  >
                    <MdModeEdit />
                    Edit
                  </div>
                  <div
                    className={styles.PopoverContent}
                    onClick={() => {
                      params?.handleBlockUnblock(record?.id);
                    }}
                  >
                    <img src={BlockIcon} alt={"block"} />
                    Block
                  </div>
                </ConditionalRender>
                <ConditionalRender visible={!!!!params?.blockedJob}>
                  <div
                    className={styles.PopoverContent}
                    onClick={() => {
                      params?.handleBlockUnblock(record?.id);
                    }}
                  >
                    <img src={UnblockIcon} alt={"unblock"} />
                    Unblock
                  </div>
                </ConditionalRender>
              </>
            }
          >
            <EllipsisOutlined
              style={{ fontSize: "30px", color: "#C3C8CD" }}
              className="action-ellipsis-button"
            />{" "}
          </Popover>
        </ConditionalRender>
      );
    },
  },
];

export const jobTableConstants = {
  BUTTON: {
    ADD_JOB_LABEL: "+ Add Job",
  },
  NO_ACCESS_JOB_DB: "Access required to view Job Profile in database",
  SHOW_BLOCKED_TOGGLE: "Show blocked",
  BLOCK_TITLE: "Block Job",
  UNBLOCK_TITLE: "Unblock Job",
  BLOCK_MESSAGE: "Are you sure you want to block this job ?",
  UNBLOCK_MESSAGE: "Are you sure you want to unblock this job ?",
  SEARCH: "Search",
  ENTER_KEY: "Enter",
};
